import React, { Suspense, useEffect } from "react";
import { Link } from "react-router-dom";

// UI Components
import { Button, Form, Row, Col, Container, Card } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";

// Utilities
import { Group } from "../../utils/logger";

// Custom Components
import LogInMicrosoft from "./LogIn.Microsoft";
import Copyright from "../../components/Env/Copyright";
import MB_Logo from "../../assets/images/mb_logo.png";

const LoggerGroup = new Group("Register");

export default function Register() {
  useEffect(() => {
    LoggerGroup.emit("Loaded");
  });

  function handleSubmit(e: any) {
    e.preventDefault(); // Prevent page from submitting

    const newUser = {
      firstName: e.target.firstName.value,
      lastName: e.target.lastName.value,
      email: e.target.email.value,
      password: e.target.password.value,
    };

    console.log("Register Form", newUser);
  }

  return (
    <Suspense fallback={null}>
      <Container data-testid="register">
        <Row className="justify-content-md-center align-items-center" style={{ height: "90vh" }}>
          <Col md={8} xl={6}>
            <Card>
              <Card.Img
                variant="top"
                src={MB_Logo}
                style={{ width: "50%" }}
                className="mx-auto mt-3"
              />

              <Card.Body className="text-center pb-0">
                <FontAwesomeIcon icon={faUserPlus} size="2x" />

                <Card.Title>Sign Up</Card.Title>
              </Card.Body>

              <Card.Body>
                <Form noValidate onSubmit={handleSubmit}>
                  <Row>
                    <Col xs={12} sm={6}>
                      <Form.Group>
                        <Form.Label>First Name</Form.Label>

                        <Form.Control
                          id="firstName"
                          name="firstName"
                          placeholder="First Name"
                          autoComplete="fname"
                          autoFocus
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} sm={6}>
                      <Form.Group>
                        <Form.Label>Last Name</Form.Label>

                        <Form.Control
                          id="lastName"
                          name="lastName"
                          placeholder="Last Name"
                          autoComplete="lname"
                          autoFocus
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12}>
                      <Form.Group>
                        <Form.Label>Email Address</Form.Label>

                        <Form.Control
                          id="email"
                          type="email"
                          name="email"
                          placeholder="sample@email.com"
                          autoComplete="email"
                          autoFocus
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12}>
                      <Form.Group>
                        <Form.Label>Password</Form.Label>

                        <Form.Control
                          id="password"
                          type="password"
                          name="password"
                          placeholder="sample@email.com"
                          autoComplete="current-password"
                          autoFocus
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Button type="submit" color="primary" block>
                    Sign In
                  </Button>

                  <Row>
                    <Col className="text-right">
                      <Link to="/auth/sign-in">
                        <small>Already have an account? Sign in</small>
                      </Link>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>

              <Card.Body className="text-center">
                <hr />

                <LogInMicrosoft />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Copyright />
          </Col>
        </Row>
      </Container>
    </Suspense>
  );
}
